<div class="input-group d-flex justify-content-end">
    <input type="text" class="form-control border-secondary rounded-start-pill px-3" id="searchTerms" name="searchTerms"
        placeholder="Search terms" aria-label="Search terms" aria-describedby="button-search"
        [(ngModel)]="searchTerms" />
    <button
        class="btn btn-outline-secondary px-3 {{ searchTerms == '' ? 'rounded-end-pill border-start-0' : 'border-end-0' }}"
        type="button" id="button-search" name="button-search" (click)="searchData(false)"><i class="bi bi-search"></i>
    </button>
    @if (searchTerms != '') {
    <button class="btn btn-outline-secondary px-3 rounded-end-pill" type="button" id="button-clear"
        (click)="searchData(true)">
        <i class="bi bi-x-circle"></i>
    </button>
    }
    <div class="form-check form-switch ms-1 ps-5 pe-2 py-2" title="Show only deleted data">
        <i class="bi {{ onlyTrashed === true ? 'bi-trash3-fill' : 'bi-trash3' }}"></i>
        <input class="form-check-input" type="checkbox" role="switch" id="onlyTrashed" name="onlyTrashed"
            [(ngModel)]="onlyTrashed" (change)="searchWithTrashed(onlyTrashed)" />
    </div>
</div>